
export const emptyViewData = () => {
  return {
    feedbackEmpty: false, // there is ZERO feedback
    isNewUser: true,
    npsData: false,
    csatData: false,
    
    //build widget after a minute of adding new widgets
    buildWidgetsTimeout: false,
    //if user leaves, then B/E scheduler will pick it up

    starData: false,
    currentShowcased: [],
    currentShowcasedIDs: [],
    showcasedItems: [],
    business: {
      name: '',
      businessID: '',
      feedbackAddressHandle: '',
      publicFeedbackDetail: false,
      externalPlatforms: {
        ca:false,
        fb:false,
        fs:false,
        g2:false,
        gp:false,
        ta:false,
        tp:false,
        tw:false,
        ye:false
      }
    },
    sentimentSummary: {
      type: '30day',
      old: 70,
      new: 74
    },
    textInviteRecord: [],
    emailInviteRecord: [],
    users: [],
    forwardContacts: [],
    
    //all showcase widgets
    currentWidgets: [],

    //all showcase tags
    currentTags: [], 

    //responses based on current filters
    viewFeedback: [],

    //results of question based on current filters
    viewQuestionResults: false,

    //questions that are filterable
    questionsWithResponses: [],

    feedbackChecked: false,
    reviews: {
      gp: {
        loading: false,
        currentThreshold: 50,
        reviews: [],
        lastSnapDoc: false
      },
      tp: {
        loading: false,
        currentThreshold: 50,
        reviews: [],
        lastSnapDoc: false
      },
      ta: {
        loading: false,
        currentThreshold: 50,
        reviews: [],
        lastSnapDoc: false
      },
      g2: {
        loading: false,
        currentThreshold: 50,
        reviews: [],
        lastSnapDoc: false
      },
      fb: {
        loading: false,
        currentThreshold: 50,
        reviews: [],
        lastSnapDoc: false
      },
      ca: {
        loading: false,
        currentThreshold: 50,
        reviews: [],
        lastSnapDoc: false
      },
      fs: {
        loading: false,
        currentThreshold: 50,
        reviews: [],
        lastSnapDoc: false
      },
      ye: {
        loading: false,
        currentThreshold: 50,
        reviews: [],
        lastSnapDoc: false
      }
    }
   }
}

export const emptyViewState = () => {
  return {
  widgetsLoaded: false,
  showcaseDataLoaded: false,
  showcasedItemsLoaded: false,
  officalLanguagesLoaded: false,
  initialFeedbackLoaded: false,
  wigetsAreLoading: false,
  viewResponseFilters: {
    periodWasChanged: false,
      startTime: null, //directly mapped to UI
      endTime: null,  //directly mapped to UI           
      showPositive: true,
      showNeutral: true,
      showNegative: true,
      showNoRating: true,
      showSpam: false,
      text: '',
      page: {
        index: 0,
        hasMore: false,
        ///startingPoint: === index times perPage
        perPage: 100 //MUST BE SYNCED WITH BACKEND code
      },
      questionID: null,
      showOnlyAnswers: []
    },  
  selectedScorePeriod: '7',
  checkedShares: [],
  entityLoaded: false,
  createTagText: '',
  showCreateTagModal: false,
  createTagCall: () => {},
  processingPayment: false,
  modal: false,
  selectedShare: false, // for one share selected
  selectedSharesview: [],
  selectedShareslist: [],
  selectedShareslistName: '', // for name of list in db
  selectedSharesquestion: [], // for multiple shares selected
  selectedShareslistListID: '',
  loadingShareLink: false,
  currentShareLink: false,
  loadingFullScreen: false,
  loadingFeedback: false,
  modalConfirmation: false,
  showPreview: false,
  questionsLoaded: false,
  noFilteredSessions: {
    question: false,
    list: false,
    view: false
  },
  selectedResponse: false, // FOR add to list
  section: 'feedback',
  page: 'view',
  currentQuestion: false,
  currentList: false,
  isExampleFeedback: false,
  notificationText: false
  }
}
